import classNames from "classnames"
import React, { FC } from "react"

type Props = {
  className?: string
  color?: "main" | "white"
  size?: number
}

const Spinner: FC<Props> = ({
  className,
  color = "main",
  size = 50
}) => (
  <div className={classNames("spinner", { [`spinner--${color}`]: true }, className)}>
    <svg viewBox="0 0 50 50" width={size} height={size}>
      <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5"/>
    </svg>
  </div>
)

export default Spinner
